import { useUserContext } from 'src/context/user';
import { isNotProduction as checkIfNotProduction } from 'src/utils/env/isNotProduction';

export const useDevToolPermissions = () => {
  const user = useUserContext();
  const isNotProduction = checkIfNotProduction();

  return isNotProduction !== undefined && (isNotProduction || user.user?.isStaff);
};
